<template>
  <div class="container">
    <div class="header-text">活動說明</div>

    <div class="banner" v-if="type == 'uupay'" @click="openUupayWeb()">
      <img class="" src="../../assets/images/cashback2021/uupayBanner.png" width="100%" />
    </div>
    <div class="banner" v-else @click="openEasycardWeb()">
      <img class="easycard" src="../../assets/images/cashback2021/easycardBanner.png" width="100%" />
    </div>

    <div class="line" />

    <div v-if="type === 'uupay'">
      <div class="section">
        <div class="section-header">如何獲得回饋 ?</div>
        <div class="section-content">
          <div class="description-box">
            <div class="description-img">
              <img src="../../assets/images/cashback2021/icon3000Method1@3x.png" width="48px" />
            </div>
            <div class="description-text">
              綁定後，於
              <span class="description-bold">10/8</span>
              日起使用悠遊付付 款，會自動累計消費金額。
            </div>
          </div>

          <div class="description-box">
            <div class="description-img">
              <img src="../../assets/images/cashback2021/icon3000Method4@3x.png" width="48px" />
            </div>
            <div class="description-text">
              支付方式可選
              <span class="description-bold">悠遊付錢包、銀行帳 戶、信用卡扣款。</span>
            </div>
          </div>

          <div class="description-box">
            <div class="description-img">
              <img src="../../assets/images/cashback2021/icon3000Method5@3x.png" width="48px" />
            </div>
            <div class="description-text">
              <span class="description-bold">消費 7 天後</span>
              ，如無退款，則直接回饋等值消費金額至悠遊付帳戶內。
            </div>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="section-header-red section-header">哪些消費可以累計？</div>
        <div class="section-content">
          <div class="description-box1">
            <div class="description-img">
              <img src="../../assets/images/cashback2021/iconCheckGreen@3x.png" width="16px" />
            </div>
            <div class="description-text"><span class="description-bold">電商網購、實體店面、攤商、交通等 都可以累計</span></div>
          </div>
          <div class="description-small">電商網購、實體店面、超市、夜市、傳統市場、商圈、藝文活動、買高鐵票、買台鐵票、搭捷運可以累計</div>

          <div class="description-box1">
            <div class="description-img">
              <img src="../../assets/images/cashback2021/iconUncheck@3x.png" width="16px" />
            </div>
            <div class="description-text"><span class="description-bold">水電費、繳費稅、儲值等不可以累計</span></div>
          </div>
          <div class="description-small">水電費、繳稅、繳罰單、規費、菸品、保險費、股票、國⺠年金、繳卡費、禮券、卡片儲值 不可以累計</div>
        </div>
      </div>
    </div>

    <div v-if="type === 'easycard'">
      <div class="section">
        <div class="section-header">如何獲得回饋 ?</div>
        <div class="section-content">
          <div class="description-box">
            <div class="description-img">
              <img src="../../assets/images/cashback2021/icon3000Method6@3x.png" width="48px" />
            </div>
            <div class="description-text">
              綁定後，於
              <span class="description-bold">10/8</span>
              日起使用 本人名下的記名悠遊卡 消費，會自動累計消費金額(無須手動選擇要累計消費的卡片)
            </div>
          </div>

          <div class="description-box">
            <div class="description-img">
              <img src="../../assets/images/cashback2021/icon3000Method5@3x.png" width="48px" />
            </div>
            <div class="description-text">
              自 <span class="description-bold">10/27</span> 起，持卡人消費 <span class="description-bold">7 天後</span>，如 無退款，將於 <span class="description-bold">每週三</span> 提供 <span class="description-bold">前前週四 至前週三 </span>清算之振興回饋金。
            </div>
          </div>

          <div class="description-box">
            <div class="description-img">
              <img src="../../assets/images/cashback2021/icon3000Method7@3x.png" width="48px" />
            </div>
            <div class="description-text">
              <span class="description-bold">持本人名下的悠遊卡</span>
              至統一超商、全 家便利商店、萊爾富與 OK 超商靠卡 加值，領取振興回饋金。
            </div>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="section-header-red section-header">哪些消費可以累計？</div>
        <div class="section-content">
          <div class="description-box1">
            <div class="description-img">
              <img src="../../assets/images/cashback2021/iconCheckGreen@3x.png" width="16px" />
            </div>
            <div class="description-text"><span class="description-bold">電商網購、實體店面、攤商、交通等 都可以累計</span></div>
          </div>
          <div class="description-small">電商網購、實體店面、超市、夜市、傳統市場、商圈、藝文活動、買高鐵票、買台鐵票、搭捷運可以累計</div>

          <div class="description-box1">
            <div class="description-img">
              <img src="../../assets/images/cashback2021/iconUncheck@3x.png" width="16px" />
            </div>
            <div class="description-text"><span class="description-bold">水電費、繳費稅、儲值等不可以累計</span></div>
          </div>
          <div class="description-small">水電費、繳稅、繳罰單、規費、菸品、保險費、股票、國⺠年金、繳卡費、禮券、卡片儲值 不可以累計</div>
        </div>
      </div>
    </div>

    <div class="faq" v-if="type == 'uupay'" @click="openUupayFAQ()">常見問題</div>
    <div class="faq" v-else @click="openEasycardFAQ()">常見問題</div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  name: 'cashback2021',
  data() {
    return {
      type: 'uupay',
    };
  },
  mounted() {
    if (this.$route.query.type != null) {
      this.type = this.$route.query.type;
    }
  },
  computed: {},
  methods: {
    ...mapActions(['sentApp']),
    openExternalLink(url) {
      this.sentApp({
        action: 'openExternalBrowser',
        payload: { url: url },
      });
    },
    openUupayFAQ() {
      this.openExternalLink('https://epkaw.easycard.com.tw/secureRedirect?link=https%3A%2F%2Flihi1.com%2FKG7uF&verify=3beb75626c3cfb8be9ac790d47773929dbb3bcc63b9e3345244b27162037d866');
    },
    openEasycardFAQ() {
      this.openExternalLink('https://epkaw.easycard.com.tw/secureRedirect?link=https%3A%2F%2Flihi1.com%2FKG7uF&verify=3beb75626c3cfb8be9ac790d47773929dbb3bcc63b9e3345244b27162037d866');
    },
    openUupayWeb() {
      this.openExternalLink('https://epkaw.easycard.com.tw/secureRedirect?link=https%3A%2F%2Flihi1.com%2FXC61e&verify=59727340407f30e0089bc059953140b5eadca32cff2efee07c89ba3c3120d47e');
    },
    openEasycardWeb() {
      this.openExternalLink('https://epkaw.easycard.com.tw/secureRedirect?link=https%3A%2F%2Flihi1.com%2FO3uZ1&verify=208c58125eeeef769baff899de5783966b61c2098b78885e82a935e6533a9551');
    },
  },
};
</script>
<style lang="scss" scoped>
.description-box {
  display: flex;
  margin-bottom: 12px;
  margin-top: 12px;
}

.description-box1 {
  display: flex;
  margin-top: 12px;
}

.description-img {
  display: inline-block;
  flex: 1;
}

.description-text {
  margin-left: 12px;
  display: inline-block;
  flex-grow: 2;  
}

.description-bold {
  color: #404040;
}

.description-small {
  font-size: 14px;
  margin-bottom: 12px;
  margin-top: 4px;
}

.container {
  position: relative;
  padding: 32px 20px;
}

.faq {
  color: #404040;
  font-size: 14px;
  text-decoration: underline;
  text-align: center;
  margin-top: 24px;
  margin-bottom: 32px;
}

.section {
  box-shadow: 0 7pt 14pt rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 24px;
}

.section-header {
  padding: 13px 15px;
  background-color: #00a12d;
  color: white;
  font-size: 16px;
  font-family: PingFangTC-Medium;
}

.section-header-red {
  background-color: #e7007f;
}

.section-content {
  padding: 4px 16px;
  color: #404040aa;
}

.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;

  &:nth-child(2) {
    margin: 32px 0 32px 0;
  }
}

.line {
  background-color: #40404010;
  height: 1px;
  width: 100%;
  margin: 24px 0;
}

.banner {
  margin-top: 12px;
}

.header {
  background-color: #007ac8;
  width: 4px;
  height: 100%;
  min-height: 16px;
  display: inline-block;
}

.header-text {
  border-left-width: 4px;
  border-left-color: #007ac8;
  border-left-style: solid;
  padding-left: 8px;
  display: inline-block;
  margin-left: 8px;
  vertical-align: ce;
}

.title {
  color: rgb(40, 40, 40);
  font-size: 24px;
  font-family: PingFangTC-Medium;
  text-align: center;
  margin: 40px 0 24px 0;
}

.text {
  font-family: PingFangTC-Medium;
  color: rgb(64, 64, 64);
  font-size: 16px;
}

.text-gray {
  font-family: PingFangTC-Regular;
  color: rgba(40, 40, 40, 0.48);
  font-size: 14px;
}

.desc-wrap {
  position: relative;

  &:after {
    content: '';
    position: absolute;
    left: 20px;
    top: 0;
    //border: 1pt dashed rgba(64, 64, 64, 0.2);
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%2340404047' stroke-width='3' stroke-dasharray='3%2c 10' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
    background-size: 100% 90%;
    height: 90%;
    width: 1px;
    z-index: 0;
  }
}

.alert {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 160px;
  height: 160px;
  background-color: #fff;
  border-radius: 16pt;
  box-shadow: 0 6pt 10pt 0 rgba(64, 64, 64, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  span {
    font-family: PingFangTC-Medium;
    font-size: 16px;
    color: rgb(64, 64, 64);
    margin-top: 16px;
  }
}

.toolTips-wrap {
  margin-top: 40px;
}

.toolTips {
  background-color: rgb(51, 51, 51);
  color: rgb(249, 249, 249);
  font-family: PingFangTC-Regular;
  font-size: 14px;
  text-align: center;
  border-radius: 3pt;
  padding: 10pt;
  width: 80%;
  margin: 0 auto;
  position: relative;

  &:after {
    content: '';
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid rgb(51, 51, 51);
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
  }
}

@media screen and (max-width: 320px) {
  .container {
    padding: 15pt 20pt;
  }

  .title {
    margin: 16px 0;
  }
  .code {
    margin: 24px 0 16px 0;
  }

  .flex-row {
    &:nth-child(2) {
      margin: 22px 0 20px 0;
    }
  }

  .toolTips-wrap {
    margin-top: 24px;
  }
}
</style>
